module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_01_6NW26_1SC_G1W.9d8be774.png";